import type { PropsWithChildren } from 'react';

export interface PropertyListKeyProps extends PropsWithChildren {}

export function PropertyListKey({ children }: PropertyListKeyProps) {
  return <dt className="text-subtle">{children}</dt>;
}
PropertyListKey.displayName = 'PropertyListKey';
